import {
  DeleteIcon,
  Divider,
  GKButton,
  GKTextField,
  Grid2,
  IconButton,
  PopConfirm,
} from "components";
import { useMutation } from "hooks/useQueries";
import { useState } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { updatePortfolio } from "store/slices/portfolioSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import axiosInstance from "utils/axiosInstance";
import { refetchQuery } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";

const NomineeTab = ({ portfolioData }: any) => {
  const form = useFormContext();

  const dispatch = useAppDispatch();

  const updatePortfolioLoading = useAppSelector(
    (state) => state?.portfolio?.loading,
  );

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "nominees",
  });

  const [confirmationModal, setConfirmationModal] =
    useState<HTMLElement | null>(null);
  const [clientBankId, setClientBankId] = useState(0);

  const { mutate: handleDeleteMutation } = useMutation({
    mutationKey: ["DELETE_CLIENT_NOMINEE"],
    mutationFn: ({ id }: { id: any }) =>
      axiosInstance.delete(`/client/${id}/nominees/`),
    onSuccess: () => {
      refetchQuery(QueryKeys.CLIENT_NOMINEE_ACCOUNT);
    },
  });

  return (
    <>
      <Grid2 size={12} container spacing={1}>
        <Grid2 size={12}>
          {fields.map((row: any, index: number) => (
            <Grid2
              container
              size={12}
              spacing={1}
              my={1}
              display={"flex"}
              alignItems={"center"}
            >
              <Grid2 size={3}>
                <Controller
                  control={form.control}
                  name={`nominees.${index}.name`}
                  render={({ field }) => (
                    <GKTextField {...field} inputLabel="Nominee Name" />
                  )}
                />
              </Grid2>
              <Grid2 size={3}>
                <Controller
                  control={form.control}
                  name={`nominees.${index}.percentage`}
                  render={({ field }) => (
                    <GKTextField {...field} inputLabel="Nominee Percentage" />
                  )}
                />
              </Grid2>
              <Grid2 size={3}>
                <Controller
                  control={form.control}
                  name={`nominees.${index}.relationship`}
                  render={({ field }) => (
                    <GKTextField {...field} inputLabel="Relationship" />
                  )}
                />
              </Grid2>
              <Grid2
                container
                size={3}
                spacing={1}
                key={index}
                my={1}
                display={"flex"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                gap={2}
              >
                <GKButton
                  style={{
                    marginTop: 18,
                  }}
                  size="small"
                  variant={"link"}
                  loading={updatePortfolioLoading}
                  color="dark"
                  onClick={(e) => {
                    e.stopPropagation();
                    let data = {};
                    if (portfolioData?.nominees?.includes(row?.rowId)) {
                      data = {
                        ...portfolioData,
                        nominees: portfolioData?.nominees?.filter(
                          (data: any) => data !== row?.rowId,
                        ),
                      };
                    } else {
                      data = {
                        ...portfolioData,
                        nominees: [...portfolioData?.nominees, row?.rowId],
                      };
                    }

                    dispatch(
                      updatePortfolio({
                        id: portfolioData?.id,
                        portfolioUpdateData: {
                          ...data,
                        },
                      }),
                    );
                  }}
                >
                  {portfolioData?.nominees?.includes(row?.rowId)
                    ? "Unassign"
                    : "Assign"}
                </GKButton>
                <IconButton
                  className="outline"
                  style={{
                    marginTop: 18,
                  }}
                  color="error"
                  disabled={fields?.length === 1}
                  onClick={(e) => {
                    if (row?.rowId) {
                      setClientBankId(row?.rowId);
                      setConfirmationModal(e.currentTarget);
                    } else {
                      remove(index);
                    }
                  }}
                >
                  <DeleteIcon width={18} />
                </IconButton>
              </Grid2>
            </Grid2>
          ))}
        </Grid2>
        <Grid2 size={12}>
          <Divider>
            <GKButton
              onClick={() =>
                append({ name: "", percentage: "", relationship: "" })
              }
              variant="outlined"
              size="small"
              color="dark"
            >
              Add New
            </GKButton>
          </Divider>
        </Grid2>
      </Grid2>

      {Boolean(confirmationModal) && (
        <PopConfirm
          anchorEl={confirmationModal}
          open={Boolean(confirmationModal)}
          setOpen={setConfirmationModal}
          onSuccess={() => handleDeleteMutation({ id: clientBankId })}
        />
      )}
    </>
  );
};

export default NomineeTab;
